export const markFirstAndLast = (msgs = []) => {
  const messages = JSON.parse(JSON.stringify(msgs))
  const lastMessageableFlags = {}
  const firstMessagebaleIndexes = {}
  let deletedDocumentMessageIndex = 0

  const getKey = (message) => {
    let key;
    if (message.messageable) {
      let message_of_calculated = message.message_of
      if (message_of_calculated === 'invoice')
        message_of_calculated = 'payment'
      key = message_of_calculated + '-' + message.messageable.uid
    }
    // documents don't have a messageable so we need to manage the unique identifier manually
    else if (message.message_of == 'document' && !message.messageable){
      key = message.message_of + '-deleted-' + deletedDocumentMessageIndex
      deletedDocumentMessageIndex = deletedDocumentMessageIndex + 1
    }

    return key
  }

  // mark first occurance of a messageable as "lastOfMessageable", and keep an index of the last occurence
  messages.forEach((message, index) => {
    let systemMessage = message.direction !== 'client_to_business' && message.direction !== 'business_to_client'
    if (message.message_of === 'message') return

    let messageableKey = getKey(message)
    // if messageable is not found yet it means that it is the first occurance
    if (!lastMessageableFlags[messageableKey]) {
      messages[index].lastOfMessageable = true
      messages[index].showEntityCard = message.message_of !== 'announcement'
      messages[index].showEntityLink = false
      lastMessageableFlags[messageableKey] = true // don't mark other messages of that item as complex
    } else {
      messages[index].lastOfMessageable = false // clean other messages lastOfMessageable flag
      messages[index].showEntityCard = false
      messages[index].showEntityLink = true
    }

    // set current messageable as the first, unless another messageable occurence will override
    firstMessagebaleIndexes[messageableKey] = index
  })

  Object.keys(firstMessagebaleIndexes).forEach((savedIndex) => {
    const index = firstMessagebaleIndexes[savedIndex]
    messages[index].firstOfMessageable = true
  })

  return messages
}
